import { useCallback, useState } from 'react';

export const useSelection = (limit: number) => {
  const [selected, setSelected] = useState<Set<string>>(new Set());

  const toggle = useCallback(
    (id: string) =>
      setSelected((current) => {
        const next = new Set(current);
        if (next.has(id)) next.delete(id);
        else if (next.size < limit) next.add(id);
        return next;
      }),
    [limit],
  );

  const clear = useCallback(() => setSelected(new Set()), []);

  return { selected, toggle, clear };
};
